import React from 'react'; 

interface SubmitButtonProps {
    name: string;
    label?: string;
    isdisabled?: boolean;
}

const SubmitButton = function SubmitButton({
    name, isdisabled, label = "Submit",
} : SubmitButtonProps) {
    return (
        <button
            disabled={isdisabled}
            className="button is-info"
            type="submit"
            name={name}
        >
            {label}
        </button>
    );
};

export default SubmitButton;
